<template>
    <div>
        <h5>Column Editor</h5>
        <b-alert v-model="showDismissibleAlert" dismissible>
            Drag and drop the columns from the left list to add them to this
            template.
            <br />Drag and drop them vertically to save the order of columns in
            the report.
        </b-alert>
        <div class="row">
            <div class="col-6 available-fields">
                <div class="column-editor-header">Available columns</div>
                <draggable
                    class="list-group"
                    :list="available"
                    group="columns"
                    @start="isDragging = true"
                    @end="isDragging = false"
                    @change="emitSelected"
                >
                    <div
                        class="column-editor-item"
                        v-for="element in available"
                        :key="element.id"
                    >
                        {{ element.name }}
                    </div>
                </draggable>
            </div>
            <div class="col-6 selected-fields">
                <div class="column-editor-header">Columns in this template</div>
                <draggable
                    class="list-group"
                    :list="selected"
                    group="columns"
                    @start="isDragging = true"
                    @end="isDragging = false"
                    @change="emitSelected"
                >
                    <div
                        class="column-editor-item"
                        v-for="element in selected"
                        :key="element.id"
                    >
                        <input
                            type="hidden"
                            name="columns[]"
                            :value="element.id"
                        />
                        <b-row>
                            <b-col>{{ element.name }}</b-col>
                            <b-col class="text-right">
                                <b-form-checkbox
                                    name="required[]"
                                    :value="element.id"
                                    v-model="required"
                                    switch
                                    @change="emitRequired"
                                    >Required</b-form-checkbox
                                >
                            </b-col>
                        </b-row>
                    </div>
                </draggable>
            </div>
        </div>
    </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "ReportTemplatesCreate",
  components: {
    draggable
  },
  props: {
    initialAvailable: {
      type: Array,
      default: () => []
    },
    initialSelected: {
      type: Array,
      default: () => []
    },
    initialRequired: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      required: this.initialRequired,
      isDragging: false,
      showDismissibleAlert: true,
      available: this.initialAvailable,
      selected: this.initialSelected
    };
  },
  methods: {
    emitSelected() {
      this.$emit("update:selected-columns", this.selected);
    },
    emitRequired() {
      this.$emit("update:required-columns", this.required);
    }
  }
};
</script>
